export default "__VITE_ASSET__0576a155__"